<template>
  <div ref="vModel">
    <div
      class="fixed bg-black bg-opacity-25 w-full h-screen flex justify-center items-center overflow"
      style="z-index: 1000000"
      v-if="active"
    >
      <div
        id="VModel-customen"
        class="container-model w-4/5 md:w-8/12 h-60 bg-white rounded-lg border border-solid shadow-md"
      >
        <div
          v-if="header"
          class="model-header p-3 py-3 border border-t-0 border-l-0 border-r-0 flex justify-between items-center"
        >
          <h5 class="truncated w-full">{{ title }}</h5>
          <vs-button type="flat" icon-pack="feather" icon="icon-x" @click="closed"></vs-button>
        </div>
        <div
        
          class="model-body overflow-auto bg-white rounded-b-lg max-vh-80 relative"
          :class="header ? ['min-height-50', Clases] : ['min-height-60', 'rounded-t-lg', Clases]"
        >
          <slot></slot>
          <vs-button
            v-if="!header"
            class="absolute right-0 top-0"
            type="flat"
            icon-pack="feather"
            icon="icon-x"
            @click="closed"
          ></vs-button>
        </div>
        <!-- <div class="model-footer p-3 border border-b-0 border-l-0 border-r-0">
          <vs-button color="success" type="border" @click="closed">Closed</vs-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    header: {
      type: Boolean,
      default: true
    },
    Clases: {
      required: false,
      type: String,
      default: "p-3"
    }
  },
  mounted() {
    this.insertBody();
  },
  beforeDestroy() {
    this.destroyed();
  },
  methods: {
    closed() {
      this.$emit("update:active", false);
    },
    destroyed() {
      const elX = this.$refs.vModel;
      const id = elX.getAttribute("id");
      if (id) {
        const bodyHasElement = document.body.querySelectorAll(`#${id}`).length;
        if (bodyHasElement > 0) return document.body.removeChild(elX);
      } else document.body.removeChild(elX);
    },
    insertBody() {
      const elX = this.$refs.vModel;
      document.body.insertBefore(elX, document.body.firstChild);
    }
  }
};
</script>

<style lang="scss" scoped>
.h-60 {
  min-height: 60vh !important;
  height: auto !important;
}

.max-vh-80 {
  max-height: 80vh;
}

.min-height-50 {
  min-height: 50vh;
}

.min-height-60 {
  min-height: 60vh;
}
</style>
